import { Component, OnInit, HostBinding, Input, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { routerTransition } from '@libs/portal-common/system';

import { LocationsService, AccessManagementService } from '@libs/portal-common/services';
import { daysOfWeek } from '@libs/portal-common/shared';

import { HeatmapFilter } from '../heatmap.component';

import { ActivityReportName } from '@libs/portal-common/services';
import { GridStateManagerService, IFilterGridState, GridStateNormalizers, IGridStateManagerConfig } from '@libs/portal-common/shared';

interface IGridState extends IFilterGridState<HeatmapFilter> {
  filter: HeatmapFilter;
}

@Component({
  selector: 'app-heatmap-container',
  templateUrl: './heatmap-container.component.html',
  styleUrls: ['./heatmap-container.component.scss'],
  animations: [routerTransition],
})
export class HeatmapContainerComponent implements OnInit, OnDestroy {
  @HostBinding('@routerTransition') routerTransition = '';

  @Input() disabled = false;

  loading = false;

  days = [];

  locations = [];
  filteredLocations = [];

  filter = new HeatmapFilter();
  displayLocations = false;

  private gridStateManager: GridStateManagerService<IGridState>;

  intervals = [
    { minutes: 30, name: '30 minutes' },
    { minutes: 60, name: '60 minutes' },
  ];

  constructor(
    private locationsService: LocationsService,
    private accessManagementService: AccessManagementService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    this.days = daysOfWeek;
  }

  handleDaysFilter(value) {
    this.days = daysOfWeek.filter((s) => s.Name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }
  handleLocationsFilter(value) {
    this.filteredLocations = this.locations.filter((s) => s.LotName.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  ngOnInit() {
    this.initializeGridStateManager();
    this.init();
  }

  ngOnDestroy() {
    if (this.gridStateManager) {
      this.gridStateManager.destroy();
    }
  }

  private init() {
    if (this.accessManagementService.hasAccessPermissions({ entities: ['Locations'], access: 'CanRead' })) {
      this.displayLocations = true;

      this.locationsService.getAll().subscribe((response) => {
        this.locations = (response.Data || []).map(function (lot) {
          return {
            Id: lot.Id,
            LotName: `${lot.LotNumber} ${lot.LotName}`,
          };
        });

        this.filteredLocations = this.locations;
      });
    }
    this.search();
  }

  search() {
    this.filter = Object.assign({}, this.filter);
    this.gridStateManager.saveState();
  }

  private initializeGridStateManager(): void {
    this.gridStateManager = new GridStateManagerService<IGridState>(this.router, this.activatedRoute);

    const config: IGridStateManagerConfig<IGridState> = {
      storageKey: `ACTIVITY_GRID_STATE_${ActivityReportName.Heatmap.toUpperCase()}`,
      normalizeState: GridStateNormalizers.createGridWithFilterNormalizer(new HeatmapFilter()),
      getCurrentState: () => ({ filter: this.filter }),
      applyState: (state) => {
        this.filter = state.filter;
      },
    };

    this.gridStateManager.initialize(config);
  }

  resetFilter() {
    this.filter = new HeatmapFilter();
    this.search();
  }
}
